/**
 * Triggers `window.print()` after temporarily overriding the document's
 * `@page` rule. Use to print thermal labels at non-A4 sizes (e.g., a single
 * Zebra QR sticker) without permanently changing global print CSS.
 *
 * Returns a Promise that resolves after the print dialog closes.
 */
export function printWithPageSize(
  widthMm: number,
  heightMm: number,
  marginMm = 1
): Promise<void> {
  return new Promise((resolve) => {
    const style = document.createElement('style');
    style.setAttribute('data-dev-tools-print', 'true');
    style.textContent = `@media print { @page { size: ${widthMm}mm ${heightMm}mm; margin: ${marginMm}mm; } }`;
    document.head.appendChild(style);

    const cleanup = () => {
      window.removeEventListener('afterprint', cleanup);
      style.remove();
      resolve();
    };
    window.addEventListener('afterprint', cleanup);

    // Defer one tick so the style applies before the dialog opens.
    requestAnimationFrame(() => window.print());
  });
}
